<template>
  <div class="bg-wave w-100">
    <div class="bg-navbar px-3 pt-4">
      <div class="pl-lg-5 d-none d-sm-block">
        <div class="d-flex">
          <h5 class="font-weight-bold w-75 pt-1">
            Daily Health Monitoring
          </h5>
          <p class="w-25 px-5 text-center border-right">
            <LanguangeSwitcher />
          </p>
          <div class="w-25 pl-4">
            <Logout />
          </div>
        </div>
      </div>
      <h5 class="text-center d-sm-none font-weight-bold">
        DHM
      </h5>
    </div>
  </div>
</template>

<script>
import LanguangeSwitcher from '@/components/LanguangeSwitcher2'
import Logout from '@/components/Logout'

export default {
  name: 'Navbar',

  components: {
    LanguangeSwitcher,
    Logout
  }
}
</script>

<style scoped>
.bg-wave {
  background-image: linear-gradient(
    158.99deg,
    rgb(34, 151, 212, 0.4) 0%,
    rgb(61, 42, 124, 0.4) 100%
  );
  border-radius: 12px;
  height: 75px;
}
.bg-navbar {
  background-color: #ffffff;
  height: 100%;
  border-radius: 11px;
  border-bottom-left-radius: 15% 80%;
  border-top-right-radius: 15% 80%;
  color: black;
}
</style>
